import {
  PAGE_ID_CLASSIFY,
  PAGE_ID_PAY_AND_POST,
  PAGE_ID_SUCCESS,
  PAGE_ID_WRITE,
  PAGE_ID_MANAGE,
} from './pageUid';

export const pageLinkNames: Record<string, string> = {
  [PAGE_ID_CLASSIFY]: 'desktop_classify',
  [PAGE_ID_PAY_AND_POST]: 'desktop_pay_and_post',
  [PAGE_ID_SUCCESS]: 'desktop_success',
  [PAGE_ID_WRITE]: 'desktop_write',
  [PAGE_ID_MANAGE]: 'desktop_role_reqs',
};
